import { Money, type MoneyValue } from "../../../shared/money/Money";
import "./MoneyDisplay.css";

export function MoneyDisplay({
  value,
  size = "normal",
}: {
  value: MoneyValue;
  size?: "normal" | "large";
}) {
  return (
    <span class={`money-display${size === "large" ? " money-display--large" : ""}`}>
      {Money.format(value)}
    </span>
  );
}
